import getStore from '../store/store';
import { ClientItemId } from 'owa-client-ids';
import { getTopOfStack } from 'owa-navigation-stack';
import { CalendarViewType, PanelViewType } from '../store/schema/TimePanelStore';

export function getSelectedCalendarItemId(): ClientItemId {
    return getStore().selectedCalendarItemId;
}

export function getCalendarViewType(): CalendarViewType {
    return getTopOfcalendarViewStack();
}

export function getPanelViewType(): PanelViewType {
    return getStore().panelViewType;
}

export function getTopOfcalendarViewStack(): CalendarViewType {
    const { calendarViewStack } = getStore();
    return getTopOfStack(calendarViewStack.stack);
}

export function getStackLength(): number {
    const { calendarViewStack } = getStore();
    return calendarViewStack.stack.length;
}
